import { Container, Row, Col } from "react-bootstrap";
import styles from "./NotFoundPage.module.css";
import { LowerMainBannerHeader, UpperMainBannerHeader } from "./DataCenterSvg";
import { useState, useEffect, useRef } from "react";
import { useLang } from "../LangContext";
import { useTheme } from "../ThemeContext";
import { motion } from "framer-motion";
import MinorHeader from "./MinorHeader";
import { s } from "framer-motion/client";
import { QuestionBlock, QuestionCard } from "./QuestionsModule";

function ProsModule2({ isXl, setCurPage }) {
  const { s, toggleTheme } = useTheme();
  const { lang, changeLang, t } = useLang();
  return (
    <Row xs={1} lg={2} className="g-4">
      <Col>
        <div style={s.VSMainBanner} className={styles.half}>
          <h3 className={styles.leftHeader} style={{ color: s.DCProsHeader }}>
            {t("okakHeader")}
          </h3>
          <p
            className={`${styles.leftText} mt-3`}
            style={{ color: s.okakText }}
          >
            {t("okakText")}
          </p>
          <h1 className={styles.errCodeHeader}>404</h1>
          <p className={styles.footerText}>{t("provider")}</p>
        </div>
      </Col>
      <Col className="d-flex justify-content-center">
        <div className={styles.okakContainer}>
          <div className={`${styles.okakWrapper} mb-4`}>
            <img
              className={styles.okak}
              src="/img/okak.png"
              alt="окак"
              draggable={false}
            />
          </div>
          {/* Кнопка — может быть <button> или <Link> из react-router */}
          <button
            className={styles.okakButton}
            style={s.okakBtn}
            onClick={() => {
              setCurPage("home");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            {t("okakButton")}
          </button>
        </div>
      </Col>
    </Row>
  );
}

export default function NotFoundPage({ windowSize, setCurPage }) {
  const { lang, changeLang, t } = useLang();
  const { s, toggleTheme } = useTheme();

  return (
    <>
      <ProsModule2 isXl={windowSize.isXl} setCurPage={setCurPage} />
      <div className="mt-4"></div>
    </>
  );
}
